<template>
  <div id="membershipStep2Page"
       class="container-fluid has-action-bar has-footer">
    <ActionBar title="خرید عضویت"></ActionBar>
    <div v-if="isLoaded" class="row container mx-auto p-0  mt-2">
      <div v-for="item in items" :key="item.PackageID" class="col-12 col-sm-6 col-md-6 col-lg-4">
        <v-img :src="getImgUrl('bg-membership.png')" class="round10px bg-keyboard-shadow text-center p-3 cursor-pointer" @click="goToPackageDetail(item.PackageID)">
          <div class="">
            <v-img v-if="item.FileUrl !== null" :src="$replaceHttps(item.FileUrl)" contain height="200"></v-img>
            <div class="dark-blue-text font16px my-2">{{ item.Name }}</div>
            <div class="white--text font20px">
              {{ $computingPriceOffer(item.Price, item.Discount) }}
            </div>

            <div :class="item.Discount !== 0 ?  true: 'hide-visibility'" class="font-12 hidden-visibility-height" dir="rtl">
              <div class=" mr-3" v-bind:class="checkOffPrice(item.Discount)">
                {{ $numberWithCommas(item.Price) }}
                <span v-if="item.Price !== 0" class="pl-1" v-bind:class="checkOffPrice(item.Discount)">تومان</span>
              </div>
            </div>
            <div class="white--text  mt-4">تعداد روز فعال: {{item.ActiveDay}} </div>
<!--            <div class="white&#45;&#45;text my-4">{{ item.Description }}</div>-->
          </div>
        </v-img>
      </div>
    </div>
    <FooterMenu :currentPage="'signUp'"/>
    <v-dialog
        v-model="showLoaderDialog"
        hide-overlay
        persistent
        width="500">
      <v-card class="text-center py-5">
        <v-progress-circular
            color="primary"
            indeterminate
        ></v-progress-circular>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
let _this = null;
import ActionBar from "../components/ActionBar";
import FooterMenu from "../components/FooterMenu";

export default {
  name: "BuyMembership",
  metaInfo: {
    title: 'مسیربرتر-خرید عضویت'
  },
  components: {FooterMenu, ActionBar},
  data: () => ({
    items: [],
    showLoaderDialog: false,
    isLoaded: false,

  }),
  mounted() {
    _this = this;
    this.showLoaderDialog = true;
    this.getData()
  },
  methods: {
    getData() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "PackageManagement/List", requestOptions)
          .then(response => response.text())
          .then(result => {
            _this.showLoaderDialog = false;
            _this.items = (JSON.parse(result)).filter( x=> x.IsActive === true)
            _this.isLoaded = true
          })
          .catch(error => console.log('error', error));
    },
    getImgUrl(pic) {
      return require('../assets/img/' + pic)
    },
    goToPackageDetail(id){
      this.$router.push({path:'BuyMembershipPackageDetail',query:{PackageID:id}})
    },
    checkOffPrice(offPrice) {
      if (offPrice !== 0) {
        return 'price';
      }
    },
  }
}
</script>

